// Analytics helpers — GA4 (gtag) and GTM (dataLayer) both consume these.

export const trackEvent = (name, params = {}) => {
  try {
    const payload = { ...params, page_path: window.location.pathname };
    if (typeof window.gtag === "function") window.gtag("event", name, payload);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: name, ...payload });
  } catch {}
};

export const trackPageView = (path) => {
  try {
    if (typeof window.gtag === "function") window.gtag("event", "page_view", { page_path: path, page_title: document.title });
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: "page_view", page_path: path, page_title: document.title });
  } catch {}
};

// Fires the full conversion stack for a booked consultation:
// GA4 event, GTM dataLayer event, Meta Pixel Lead, Google Ads conversion.
export const trackConversion = (params = {}) => {
  trackEvent("book_consultation", params);
  try {
    if (typeof window.fbq === "function") window.fbq("track", "Lead", params);
    const adsId = window.__googleAdsId;
    const adsLabel = window.__googleAdsLabel;
    if (adsId && adsLabel && typeof window.gtag === "function") {
      window.gtag("event", "conversion", { send_to: `${adsId}/${adsLabel}` });
    }
  } catch {}
};

// Meta Pixel base code — init + first PageView.
export const initMetaPixel = (pixelId) => {
  if (window.fbq || !pixelId) return;
  const n = (window.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  });
  n.queue = [];
  n.loaded = true;
  n.version = "2.0";
  const s = document.createElement("script");
  s.async = true;
  s.src = "https://connect.facebook.net/en_US/fbevents.js";
  document.head.appendChild(s);
  window.fbq("init", pixelId);
  window.fbq("track", "PageView");
};

// Inject an arbitrary third-party snippet (Meta Pixel, Hotjar, TikTok…).
// <script> tags are recreated so they actually execute; runs once per id.
export const injectSnippet = (id, code, location = "head") => {
  if (!code?.trim() || document.querySelector(`[data-custom-tag="${id}"]`)) return;
  try {
    const tpl = document.createElement("template");
    tpl.innerHTML = code.trim();
    const frag = document.createDocumentFragment();
    tpl.content.childNodes.forEach((node) => {
      if (node.nodeName === "SCRIPT") {
        const s = document.createElement("script");
        [...node.attributes].forEach((a) => s.setAttribute(a.name, a.value));
        s.textContent = node.textContent;
        frag.appendChild(s);
      } else {
        frag.appendChild(node.cloneNode(true));
      }
    });
    const marker = document.createElement("span");
    marker.style.display = "none";
    marker.dataset.customTag = id;
    frag.appendChild(marker);
    if (location === "body") document.body.insertBefore(frag, document.body.firstChild);
    else document.head.appendChild(frag);
  } catch {}
};
